module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$media.desktop) ? _c('footer', {
    staticClass: "footer",
    class: _vm.classes
  }, [_c('nav', {
    staticClass: "footer__nav"
  }, [_c('router-link', {
    staticClass: "footer__node",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v(_vm._s(_vm.homeNode.meta.label))]), _vm._v(" "), _vm._l((_vm.nodes), function(node) {
    return (!node.meta.hidden && node.meta.index) ? _c('router-link', {
      staticClass: "footer__node",
      attrs: {
        "to": node.path
      }
    }, [_vm._v(_vm._s(node.meta.label))]) : _vm._e()
  })], 2), _vm._v(" "), _c('side-bar', {
    attrs: {
      "left": true,
      "to": _vm.sidebars.left ? _vm.sidebars.left.to : null,
      "modifier": _vm.sidebars.left ? _vm.sidebars.left.modifier : null
    }
  }), _vm._v(" "), (_vm.sidebars.right) ? _c('side-bar', {
    attrs: {
      "to": _vm.sidebars.right.to,
      "modifier": _vm.sidebars.right.modifier
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07375a68!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/FooterNav.vue
// module id = 622
// module chunks = 1